


export const CoffeeByIdPage = () => {
  return (
    <div>
      <h1>Coffee Details</h1>
      <p>Details about a specific coffee will be displayed here.</p>
      {/* Additional components or details can be added here */}
    </div>
  );
}